const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  menus: state => state.user.menus,
  addRouters: state => state.permission.addRouters,
  visitedViews: state => state.tagsView.visitedViews, // 曾
  cachedViews: state => state.tagsView.cachedViews,
  routers: state => state.permission.routers,
  member: state => state.permission.member,
  provider: state => state.permission.provider,
  settings: state => state.permission.settings,
  permissions: state => state.user.permissions, //按钮权限
  info: state => state.user.info, //用户信息
  dicData: state => state.dicData, //数据字典
  countData: state => state.countData,
  searchDataRemote: state => state.searchDataRemote
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js